import React from 'react';

const STRATEGIES = [
  { key: 'all', label: 'All Strategies' },
  { key: 'flip', label: 'Fix & Flip' },
  { key: 'ltr', label: 'Long-Term Rental' },
  { key: 'str', label: 'Short-Term Rental' },
];

export default function StrategySelector({ selected, onSelect }) {
  return (
    <div className="flex justify-center mb-6">
      <div className="flex flex-wrap justify-center gap-2 max-w-full" role="group" aria-label="Strategy shown">
        {STRATEGIES.map((s) => (
          <button
            key={s.key}
            type="button"
            onClick={() => onSelect(s.key)}
            aria-pressed={selected === s.key}
            className={`${
              selected === s.key
                ? 'bg-terminal-dark-green text-terminal-green border-terminal-dim-green'
                : 'bg-surface-primary text-txt-primary hover:bg-surface-elevated border-surface-border'
            } px-4 min-h-[44px] text-sm font-medium border rounded`}
          >
            {s.label}
          </button>
        ))}
      </div>
    </div>
  );
}
